var _path;

var _excluded = ["svgRef"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgIconContactNormal = function SvgIconContactNormal(_ref) {
  var svgRef = _ref.svgRef,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 21,
    ref: svgRef
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#666",
    fillRule: "evenodd",
    d: "M15.429 21H2.707c-.024 0-.045-.012-.068-.014-.024.002-.044.014-.068.014a.866.866 0 0 1-.857-.875v-3.5H.857A.866.866 0 0 1 0 15.75c0-.483.383-.875.857-.875h.857v-3.5H.857A.866.866 0 0 1 0 10.5c0-.483.383-.875.857-.875h.857v-3.5H.857A.866.866 0 0 1 0 5.25c0-.483.383-.875.857-.875h.857v-3.5c0-.483.384-.875.857-.875.024 0 .044.012.068.014C2.662.012 2.683 0 2.707 0h12.722C16.847 0 18 1.178 18 2.625v15.75C18 19.822 16.847 21 15.429 21zm-12-16.625c.473 0 .857.392.857.875a.866.866 0 0 1-.857.875v3.5c.473 0 .857.392.857.875a.866.866 0 0 1-.857.875v3.5c.473 0 .857.392.857.875a.866.866 0 0 1-.857.875v2.625h9.428V1.75H3.429v2.625zm12.857-1.75a.867.867 0 0 0-.857-.875h-.858v17.5h.858a.866.866 0 0 0 .857-.875V2.625z"
  })));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgIconContactNormal, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/icon-contact-normal.988a2c7c.svg";
export { ForwardRef as ReactComponent };